import { useContextHook } from "./ContextOPen";

function Translate() {
  const { changeLanguage, changeLanguage2 } = useContextHook();
  return (
    <div className="">
      <div className="p-1">
        <div>
          {localStorage.getItem("language") !== "en" ? (
            <div
              onClick={changeLanguage2}
              className="border w-fit px-3 cursor-pointer h-10 border-Main flex justify-center hoverMain items-center after:bg-Main rounded-full transition-all relative overflow-hidden "
            >
              <p className="z-10 cursor-pointer">EN</p>
            </div>
          ) : (
            <div
              onClick={changeLanguage}
              className="border w-fit px-3 cursor-pointer  h-10 border-Main flex justify-center hoverMain items-center after:bg-Main rounded-full transition-all relative overflow-hidden "
            >
              <p className="z-10 cursor-pointer">AR</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default Translate;
